(function (app, ng) {

    app.config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state("Home.Settings.Agency",
            {
                url: "/Agency",
                redirectTo: "Home.Settings.Agency.Users",
                component: "agency"
            });
    }]);

    app.component("agency",
        {
            templateUrl: "/App/Settings/Agency/agency-template.html",
            controller: agencyController,
            bindings: {
                currentUser: "="
            }
        });

    agencyController.$inject = [];
    function agencyController() {
        var $ctrl = this;

        ng.extend($ctrl,
            {
            });
    }

})(window.app, window.angular); // jshint ignore:line